<template>
  <div class="subscribe">
    <div @click.prevent="showDropdown"
         class="subscribe__content">
      <div class="subscribe__title">{{ $tVacancies('Subscribe to this collection:') }}</div>
      <div class="subscribe__list">
        <div v-for="(item, key) in messengers"
             :key="key"
             :class="getSelector(item, key)"
             class="subscribe__item">
          <BaseSvg :name="`ico-${key}`" :width="item.width"/>
        </div>
      </div>
    </div>
    <transition name="dropdown">
      <SubscribeDropdown v-if="isShowDropdown"
                         :pending="pending"
                         :messengers="messengers"
                         @close="hideDropdown"
                         :toggleChannel="toggleChannel"/>
    </transition>
  </div>
</template>

<script>
  import {http} from '../axios'
  import SubscribeDropdown from './SubscribeDropdown'

  export default {
    components: {
      SubscribeDropdown
    },
    props: {
      subscribed: {
        type: Object,
      },
      queryParams: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loaded: false,
        pending: false,
        isShowDropdown: false,
        messengers: {
          // viber: {
          //   name: 'Viber',
          //   selector: '_viber',
          //   width: '1.4rem'
          // },
          telegram: {
            name: 'Telegram',
            selector: '_telegram',
            width: '1.5rem'
          },
          // email: {
          //   name: 'Email',
          //   selector: '_email',
          //   width: '1.3rem'
          // },
          // sms: {
          //   name: 'SMS',
          //   selector: '_sms'
          // },
          // whatsapp: {
          //   name: 'WhatsApp',
          //   selector: '_whatsapp',
          //   width: '1.4rem',
          //   disabled: true
          // },
          // messenger: {
          //   name: 'Messenger',
          //   selector: '_messenger',
          //   disabled: true
          // },
          // skype: {
          //   name: 'Skype',
          //   selector: '_skype',
          //   disabled: true
          // },
          // slack: {
          //   name: 'Slack',
          //   selector: '_slack',
          //   width: '1.4rem',
          //   disabled: true
          // },
        }
      }
    },
    computed: {
      params() {
        return {
          category_id: this.$route.params.categoryId,
          params: this.$route.params
        }
      }
    },
    methods: {
      // load() {
      //   if (this.loaded || this.pending) return
      //
      //   this.pending = true
      //
      //   http.get('/api/cabinet/mailing/collection', {
      //     params: this.queryParams
      //   }).then(({data}) => {
      //     console.log('data', data)
      //   }).finally(() => {
      //     this.pending = false
      //   })
      // },
      toggleChannel(channel, frequency = 1) {
        this.pending = true

        http.post('/api/cabinet/mailing/set-channel', {
          channel
        }).then(({data}) => {
          const code = data.data.code
          const secureCode = data.data.secure_code
          http.post('/api/cabinet/mailing/collection', {
            params: this.queryParams,
            channel,
            frequency
          }).then(({data}) => {
            if (data.message === 'SUBSCRIBED') {
              if (channel === 'telegram' && code === 1) {
                this.runTelegramSuccess(secureCode)
              }
              this.$set(this.messengers[channel], 'selected', true)
            } else {
              this.$set(this.messengers[channel], 'selected', false)
            }

            console.log('toggleChannel', data)
          }).finally(() => {
            this.pending = false
          })
        })


      },
      getSelector(item, key) {
        return {
          ['_' + key]: true,
          _disabled: item.disabled
        }
      },
      hideDropdown() {
        this.isShowDropdown = false
      },
      showDropdown() {
        this.isShowDropdown = true
        // this.load()
      },
      runTelegramSuccess(code) {
        this.$vModal.open('telegram-success', {
          code
        })
      },
      setSubscribed() {
        const subscribed = this.subscribed
        const messengers = this.messengers

        for (const key in subscribed) {
          this.$set(messengers[key], 'selected', subscribed[key])
        }
      }
    },
    created() {
      this.setSubscribed()
    },
    watch: {
      subscribed() {
        this.setSubscribed()
      }
    }
  }
</script>

<style lang="less">

</style>